import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom';
import { Suspense } from 'react';
import { Loader } from './components/base/Loader';
import { OnboardingPage } from './components/app/shared/OnboardingPage';
import { LearnMore } from './components/app/shared/LearnMore';
import { DesktopLayout } from './components/app/shared/DesktopLayout';
import { PostJobWizard } from './components/app/homeowner/post/PostJobWizard';
import { JobsTab } from './components/app/homeowner/jobs/JobsTab';
import { Toaster } from './components/ui/sonner';
import { ProfileTab } from './components/app/shared/ProfileTab';
import { SearchJobs } from './components/app/helper/search/SearchJobs';
import AdminUsersDashboard from "./Admin/components/user-management/customerTable"
import AdminServicesManagement from "./Admin/components/services-management/customerTable"
import AdminCancelledServicesManagement from "./Admin/components/cancelled-services-management/customerTable"
import AdminQueriesManagement from "./Admin/components/queries-management/customerTable"
import AdminRefererManagement from "./Admin/components/Referral-management/customerTable"
import AdminFinancialManagement from "./Admin/components/transaction-management/customerTable"
import { useSelector } from 'react-redux';
import AdminLayout from './components/app/admin/AdminLayout';
import { JobDetailTab } from './components/app/homeowner/jobs/JobDetailTab';
import { AppliedJobs } from './components/app/helper/jobs/AppliedJobs';
import StripeJobs from './Admin/components/stripe-management/StripeJobs';

function App() {
  const { userInfo } = useSelector((state) => state.auth);
  const role = userInfo ? userInfo.user.role : null;

  return (
    <>
      <Router>
        <Suspense fallback={<Loader />}>
          <Routes>

            {/* Static Routes */}
            {!role && (
              <>
                <Route path="/" element={<OnboardingPage />} />
                <Route path="/learnMore" element={<LearnMore />} />
              </>
            )}

            {/* Homeowner Routes */}
            <Route path="/homeowner" element={<DesktopLayout type="homeowner" />}>
              <Route index element={<Navigate to="post" replace />} />
              <Route path="post" element={<PostJobWizard />} />
              <Route path="profile" element={<ProfileTab user="homeowner" />} />
              <Route path="jobs" element={<JobsTab />} />
              {role === "houseOwner" && <Route path="jobs/:jobId" element={<JobDetailTab />} />}
              <Route path="*" element={<Navigate to="post" replace />} />
            </Route>

            {/* Helper Routes */}
            <Route path="/helper" element={<DesktopLayout type="helper" />}>
              {!role ? (
                <>
                  <Route index element={<Navigate to="profile" replace />} />
                  <Route path="profile" element={<ProfileTab user="helper" />} />
                  <Route path="*" element={<Navigate to="profile" replace />} />
                </>
              ) : (
                <>
                  <Route index element={<Navigate to="search" replace />} />
                  <Route path="search" element={<SearchJobs />} />
                  <Route path="profile" element={<ProfileTab user="helper" />} />
                  <Route path="jobs" element={<AppliedJobs />} />
                  <Route path="jobs/:jobId" element={<JobDetailTab />} />
                  <Route path="*" element={<Navigate to="search" replace />} />
                </>
              )}
            </Route>

            {/* Admin Routes */}
            {role === 'admin' && (
              <Route path="/admin" element={<AdminLayout />}>
                <Route index element={<Navigate to="users" replace />} />
                <Route path="users" element={<AdminUsersDashboard />} />
                <Route path="services" element={<AdminServicesManagement />} />
                <Route path="cancelled-services" element={<AdminCancelledServicesManagement />} />
                <Route path="queries" element={<AdminQueriesManagement />} />
                <Route path="referrers" element={<AdminRefererManagement />} />
                <Route path="financials" element={<AdminFinancialManagement />} />
                <Route path="stripe-jobs" element={<StripeJobs />} />
                <Route path="*" element={<Navigate to="dashboard" replace />} />
              </Route>
            )}

            {/* * Routes */}
            {!role && <Route path="*" element={<Navigate to="/" replace />} />}
            {role === 'shoveller' && <Route path="*" element={<Navigate to="/helper" replace />} />}
            {role === 'houseOwner' && <Route path="*" element={<Navigate to="/homeowner" replace />} />}
            {role === 'admin' && <Route path="*" element={<Navigate to="/admin" replace />} />}

          </Routes>
        </Suspense>
      </Router>
      <Toaster />
    </>
  );
}

export default App;